import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UsuarioService } from 'src/app/shared/usuario.service';

export interface ISidebar {
  containerClassnames: string;
  menuClickCount: number;
  selectedMenuHasSubItems: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private initialSidebar: ISidebar = { containerClassnames: environment.defaultMenuType, menuClickCount: 0, selectedMenuHasSubItems: environment.defaultMenuType === 'menu-default' };
  private sidebar = new BehaviorSubject<ISidebar>(this.initialSidebar);
  subHiddenBreakpoint: number = environment.subHiddenBreakpoint;
  menuHiddenBreakpoint: number = environment.menuHiddenBreakpoint;

  private sidebarStatus = new BehaviorSubject<boolean>(false);
  currentStatus = this.sidebarStatus.asObservable();

  private tipoAccesoSubject = new BehaviorSubject<number | null>(null);
  tipoAcceso$ = this.tipoAccesoSubject.asObservable();

  private primerosPasosListos: number = 0;
  private tipoAcceso: number | null = null;

  constructor(private usuarioService: UsuarioService) {
    // Inicializar el estado
    this.clearState();

    // Suscribirse a cambios en el usuario
    this.usuarioService.user$.subscribe(user => {
      if (user) {
        this.primerosPasosListos = user.primerosPasosListos;
        this.handleUserState();
      } else {
        this.clearState();
      }
    });
  }

  private handleUserState() {
    console.log('handleUserState called with primerosPasosListos:', this.primerosPasosListos);
    if (this.primerosPasosListos === 0) {
      this.tipoAcceso = 1;
      this.sidebarStatus.next(false);
    } else if (this.primerosPasosListos === 1) {
      this.tipoAcceso = 2;
      this.sidebarStatus.next(true);
    }
    this.tipoAccesoSubject.next(this.tipoAcceso);
  }

  clearState() {
    this.tipoAccesoSubject.next(null);
    this.sidebarStatus.next(false);
  }

  getSidebar(): Observable<ISidebar> {
    return this.sidebar.asObservable();
  }

  setTipoAcceso(tipo: number) {
    if (this.primerosPasosListos === 0) {
      this.tipoAcceso = 1;
      this.sidebarStatus.next(false);
      this.tipoAccesoSubject.next(this.tipoAcceso);
    } else if (this.primerosPasosListos === 1) {
      this.tipoAcceso = 2;
      this.sidebarStatus.next(true);
      this.tipoAccesoSubject.next(this.tipoAcceso);
    } else {
      this.clearState();
    }
  }

  setTipoAccesoForPagesBusiness(tipo: number) {
    this.tipoAcceso = tipo;
    this.sidebarStatus.next(false);
    this.tipoAccesoSubject.next(this.tipoAcceso);
  }

  getTipoAcceso(): number | null {
    return this.tipoAccesoSubject.value;
  }

  clickOnMobileMenu = (strCurrentClasses: string) => {
    const before = this.sidebar.getValue();
    const currentClasses = strCurrentClasses ? strCurrentClasses.split(' ').filter(x => x !== '' && x !== 'sub-show-temporary') : [];
    let nextClasses = '';
    if (currentClasses.includes('main-show-temporary')) {
      nextClasses = (currentClasses.filter(x => x !== 'main-show-temporary')).join(' ');
    } else {
      nextClasses = currentClasses.join(' ') + ' main-show-temporary';
    }
    this.sidebar.next({ containerClassnames: nextClasses, menuClickCount: 0, selectedMenuHasSubItems: before.selectedMenuHasSubItems });
  }

  changeSidebarStatus(status: boolean) {
    this.sidebarStatus.next(status);
  }
}
